import script from "./InquiryDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryDetailPage.vue?vue&type=style&index=0&id=77c8fdc9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c8fdc9"]])

export default __exports__